




import { UserActivityTypes } from '@/constants/UserActivityTypes';

import OfferUserActivityTile from '@/components/Tiles/UserActivity/OfferUserActivityTile.vue';
import PayoutUserActivityTile from '@/components/Tiles/UserActivity/PayoutUserActivityTile.vue';
import SignupUserActivityTile from '@/components/Tiles/UserActivity/SignupUserActivityTile.vue';
import InHouseUserActivityTile from '@/components/Tiles/UserActivity/InHouseUserActivityTile.vue';
import OfferWallUserActivityTile from '@/components/Tiles/UserActivity/OfferWallUserActivityTile.vue';
import OfferStartedUserActivityTile from '@/components/Tiles/UserActivity/OfferStartedUserActivityTile.vue';
import ReferralEarningUserActivityTile from "@/components/Tiles/UserActivity/ReferralEarningUserActivityTile.vue";






export default class UserActivityTileFactory {
    static getComponent (userActivityType: UserActivityTypes) {
        switch (userActivityType) {
            case UserActivityTypes.USERSIGNUP:
                return SignupUserActivityTile;
            case UserActivityTypes.INHOUSETASK:
                return InHouseUserActivityTile;
            case UserActivityTypes.PAYOUTSTATUS:
                return PayoutUserActivityTile;
            case UserActivityTypes.OFFERWALL:
                return OfferWallUserActivityTile;
            case UserActivityTypes.OFFERSCALLBACK:
                return OfferUserActivityTile;
            case UserActivityTypes.OFFERSTARTED:
                return OfferStartedUserActivityTile;
            case UserActivityTypes.REFERRALEARNING:
                return ReferralEarningUserActivityTile;
            default:
                throw Error('Invalid User Activity Type');
        }
    }
}